<template>
  <component :is="currentSearchComponent" />
</template>

<script>
// import { nextTick } from 'vue';
import {
  mapState, mapActions, mapMutations, mapGetters,
} from 'vuex';
import JobsIndex from './jobs-index.vue';
import ReviewsIndex from './reviews-index.vue';
import CompaniesIndex from './companies-index.vue';

export default {
  computed: {
    ...mapState('search', {
      searchType: (state) => state.query.show,
    }),
    ...mapGetters('search', {
      getDefaultSortOrder: 'getDefaultSortOrder',
      getQueryParams: 'getQueryParams',
    }),

    currentSearchComponent() {
      const type = this.searchType;

      switch (type) {
        case 'reviews':
          return ReviewsIndex;
        case 'companies':
          return CompaniesIndex;
        case 'jobs':
        default:
          return JobsIndex;
      }
    },
  },

  created() {
    this.setInitialResults();
    window.onpopstate = this.popStateHandler;
  },

  methods: {
    ...mapActions('search', {
      setInitialResults: 'setInitialResults',
      getAjaxResults: 'getAjaxResults',
    }),
    ...mapMutations('search', {
      resetQueryParams: 'resetQueryParams',
      setTriggeredByBrowser: 'setTriggeredByBrowser',
      updateSearchUrl: 'updateSearchUrl',
      pauseQueryWatcher: 'pauseQueryWatcher',
      unPauseQueryWatcher: 'unPauseQueryWatcher',
      setLoadingState: 'setLoadingState',
    }),

    /**
     * Handling the back and forward browser button.
     * At one point I integrated it with submitSearch of index-mixin.js
     * I did it because the catch logic is repeated but I in the end reverted.
     * I preferred to keep the back/forward logic "just here" in case we need to fix any bug + simplicity
     * Sometimes DRY principle needs to be taken with moderation, I personally think this one of those times.
     */
    async popStateHandler() {
      this.updateSearchUrl(this.$router.currentRoute.value.fullPath);
      this.pauseQueryWatcher();
      this.setLoadingState({ loadingState: true });

      await this.getAjaxResults().catch((error) => {
        if (error.message === 'cancelled-request') {
          console.log('request cancelled.');
          return;
        }

        this.setLoadingState({ loadingState: false });
        this.$bus.$emit('bus:base-alert', {
          type: 'Error',
          message: this.$lang.alert.error.message,
        });
      }).finally(() => {
        this.unPauseQueryWatcher();
      });
    },
  },

};
</script>

<style lang="scss">
@import "../../../scss/abstracts/abstracts";

.Search-content {
  padding: 20px 0;
  @include respond-to(xs) {
    padding: 20px;
  }
}

.SearchLinks.Block,
.searchInput-content {
  display: none;
  @include respond-to(md) {
    display: block;
  }
}

.SearchFilters {
  & > hr.medium{
    display: none;
    @include respond-to(md){
      display: block;
    }
  }
  .Block {
    clear: both;
    height: auto;
    flex-grow: 0;
    padding: 1rem;
    &:before,
    &:after {
      content: '';
      clear: both;
      width: 100%;
      display: table;
    }
  }
}

.SearchFilter {
  margin: 1em 0;
  label {
    color: color('grey');
    display: flex;
    // align-items: center;
  }
  li {
    margin-bottom: .6rem;
    font-size: 1rem;
  }
}

.SearchFilter-title {
  font-size: 18px;
  margin-bottom: 1em;
  font-weight: 700;
}

.Sidebar,
.SearchResults,
.SearchFilters {
  .Block {
    padding: 1rem;
    width: 100%;
  }
}

  .Search-label {
    display: block;
    li {
      margin: 0 .5rem .3rem 0;
      font-size: .9rem;
      color: #333;
      // &.salary {
      //   overflow: hidden;
      //   white-space: nowrap;
      //   text-overflow: ellipsis;
      // }
      &:last-child {
        margin-right: 0;
      }
    }
  }
.SearchResults{
  @include respond-to(sm, 'max-width'){
    padding-left: 0;
    padding-right: 0;
    .Card {
      border-radius: 0;
    }
  }
}
</style>
